import { createZodDto } from "nestjs-zod/dto";
import z from "zod";
import { userSchema } from "../user";

export const creditCreationSchema = z.object({
  id: z.string(),
  quantity: z.number(),
  remain: z.number(),
  souscriptionId: z.string().optional().nullable(),
  userId: z.string(),
  user: userSchema.optional(),
  createdAt: z.coerce.date(),
});

export class CreditCreationDto extends createZodDto(creditCreationSchema) {}
